<template>
    <input
        ref="input"
        :type="type"
        :class="['form-control', validationStatus ? `is-${validationStatus}` : null]"
        :id="`input-${$.uid}`"
        :placeholder="placeholder"
        v-model="textValue"
        :pattern="pattern"
        v-bind="$attrs"
        :required="required"
        />
</template>

<script>
export default {
    name: "AlzataTextInput",
    inheritAttrs: false,
    emits: [
        'update:modelValue',
    ],
    props: {
        value: String,
        modelValue: String,
        required: Boolean,
        placeholder: String,
        updateFunction: Function,
        type: {
            type: String,
            default: 'text',
        },
        pattern: {
            type: String,
        },
        fieldFormatters: {
            default: () => [],
        },
        validationMessage: {
        },
    },
    methods: {
        focus() {
            this.$refs.input.focus();
        },
        validate() {
            this.showValidation = true;
            return this.$refs.input.matches(':valid');
        },
        formatValue(value) {
            for (var formatter of this.fieldFormatters) {
                var m = formatter.regex ? value.match(formatter.regex) : value;
                if (m !== null) {
                    value = formatter.replacer(m);
                }
            }
            return value;
        },
        clearStatus() {
            this.showStatus(null, 0);
        },
        showStatus(status, dismissAfter = 1000) {
            this.showValidation = false;
            window.clearTimeout(this.validationStatusTimer);
            this.validationStatus = status;
            if (status && dismissAfter > 0) {
                this.validationStatusTimer = window.setTimeout(() => {
                    this.validationStatus = null;
                    this.showValidation = false;
                }, dismissAfter);
            }
        },
    },
    computed: {
        statusIconStyle() {
            var styles = ['input-status'];
            if (this.statusIcon) {
                styles.push(this.statusIcon.style);
                if (this.statusIcon.visible) {
                    styles.push('input-status-visible');
                }
            }
            return styles.join(' ');
        },
    },
    beforeMount() {
        this.textValue = this.modelValue;
    },
    data() {
        return {
            showValidation: false,
            validationStatus: null,
            validationStatusTimer: null,
            textValue: "",
            statusIcon: {
                visible: false,
                style: 'bg-success',
                icon: 'check',
            },
        };
    },
    watch: {
        modelValue(newVal) {
            this.textValue = this.formatValue(newVal);
        },
        textValue(newVal) {
            const newNew = this.formatValue(newVal);
            if (newNew !== newVal){
                this.textValue = newNew;
                return;
            }
            this.$emit('update:modelValue', this.formatValue(newVal));
        },
    },
}
</script>